//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        ibsoutbound: [],
        searchRequest: {},
      },

      mutations: {
        updateibsOutbound(state, ibsoutbound) {
          state.ibsoutbound = ibsoutbound;
        },
        updateSearchibsobRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async ibsOutboundsList({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));
          
          if (requestToSend.gwDate.startDate)
          {
            requestToSend.gwDate.startDate = dateFormat.getLocalDate(requestToSend.gwDate.startDate);
          }

          if (requestToSend.gwDate.endDate)
          {
            requestToSend.gwDate.endDate = dateFormat.getLocalDateEnd(requestToSend.gwDate.endDate);
          }
          else
          {
            requestToSend.gwDate.endDate = dateFormat.getLocalDateEnd(requestToSend.gwDate.startDate);
          }

          if (requestToSend.chzEndDate.startDate)
          {
            requestToSend.chzEndDate.startDate = dateFormat.getLocalDateOnly(requestToSend.chzEndDate.startDate);
          }

          if (requestToSend.chzEndDate.endDate)
          {
            requestToSend.chzEndDate.endDate = dateFormat.getLocalDateOnly(requestToSend.chzEndDate.endDate);
          }
          else
          {
            requestToSend.chzEndDate.endDate = dateFormat.getLocalDateOnly(requestToSend.chzEndDate.startDate);
          }

          if (requestToSend.chzStartDate.startDate)
          {
            requestToSend.chzStartDate.startDate = dateFormat.getLocalDateOnly(requestToSend.chzStartDate.startDate);
          }

          if (requestToSend.chzStartDate.endDate)
          {
            requestToSend.chzStartDate.endDate = dateFormat.getLocalDateOnly(requestToSend.chzStartDate.endDate);
          }
          else
          {
            requestToSend.chzStartDate.endDate = dateFormat.getLocalDateOnly(requestToSend.chzStartDate.startDate);
          }

          if (requestToSend.outboundDate.startDate)
          {
            requestToSend.outboundDate.startDate = dateFormat.getLocalDateOnly(requestToSend.outboundDate.startDate);
          }
  
         if (requestToSend.outboundDate.endDate)
          {
            requestToSend.outboundDate.endDate = dateFormat.getLocalDateEnd(requestToSend.outboundDate.endDate);
          }
    

          console.log(requestToSend);
          const st = performance.now();
          //const result = await api.post('/api/w/fsi/GetIBSOutbound', requestToSend);
          const result = await newAPIPost('/api/w/fsi/GetIBSOutbound', requestToSend);
          commit('updateSearchibsobRequest', fallbackRequest);
          console.log(JSON.stringify(result));
          if (requestToSend.loadStatus == 'LD')
          {
            return commit('updateibsOutbound', result.filter(it => it.scaleTicket != null));
          }
          else
          {
            return commit('updateibsOutbound', result.filter(it => it.loadStatus != 'LD' || (it.loadStatus == 'LD' && it.scaleTicket != null)));
          }
          
        },
      },

      getters: {
        getibsOutbound: state => state.ibsoutbound,
      },
}
